/**
 * 网络请求模块
 */
import { get, post, qsPost } from './ApiHelper'

const BASE_URL = process.env.API_HOST;

// 查询诉求内容
export const queryAppealBack = ({ appeal_id, currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + '/queryAppealBack'
  let params = {
    body: {
      appeal_id: appeal_id,
      currentPage: currentPage,
      pageSize: pageSize
    }
  }
  return qsPost(url, params, success, fail)
}

/** 邮箱唯一校验 */
export const checkEmail = ({ email }, success, fail) => {
  let url = BASE_URL + 'checkEmail'
  let params = {
    body: {
      email: email
    }
  }
  return qsPost(url, params, success, fail);
}

/** 邮箱注册 */
export const registByEmail = ({ email, password }, success, fail) => {
  let url = BASE_URL + 'registByEmail'
  let params = {
    body: {
      email: email,
      password: password,
    }
  }
  return qsPost(url, params, success, fail);
}

/** 手机唯一校验 */
export const checkPhoneNo = ({ phoneNo }, success, fail) => {
  let url = BASE_URL + 'checkPhoneNo'
  let params = {
    body: {
      phone_no: phoneNo
    }
  }
  return qsPost(url, params, success, fail);
}

/** 发送手机验证码 */
export const sendVerifyCodeByPhone = ({ phoneNo }, success, fail) => {
  let url = BASE_URL + 'sendVerifyCodeByPhone'
  let params = {
    body: {
      phone_no: phoneNo
    }
  }
  return qsPost(url, params, success, fail);
}

/** 手机注册 */
export const registByPhoneNo = ({ phoneNo, password, verifycode, email, unit }, success, fail) => {
  let url = BASE_URL + 'registByPhoneNo'
  let params = {
    body: {
      phone_no: phoneNo,
      password: password,
      verifycode: verifycode,
      email: email,
      unit: unit,
    }
  }
  return qsPost(url, params, success, fail);
}

/** 登录 */
export const doLogin = ({ username, password, type, verifycode }, success, fail) => {
  let url = BASE_URL + 'doLogin'
  let params = {
    body: {
      username: username,
      password: password,
      type: type,
      verifycode: verifycode,
    }
  }
  return qsPost(url, params, success, fail);
}
/** 登录发送验证码 */
export const sendLoginVerifyCode = ({ phone_no }, success, fail) => {
  let url = BASE_URL + 'sendLoginVerifyCode'
  let params = {
    body: {
      phone_no: phone_no,//手机号
    }
  }
  return qsPost(url, params, success, fail);
}
/**
 * 首页
 *  */
export const selectBycate = ({ category }, success, fail) => {
  let url = BASE_URL + 'News/selectBycate'
  let params = {
    body: {
      category: category,//“tz”是通知，“dt”是动态
    }
  }
  return get(url, params, success, fail);
}

export const getPlatForm = (success, fail) => {
  let url = BASE_URL + 'getPlatForm'
  let params = {
    body: {

    }
  }
  return qsPost(url, params, success, fail);
}
/* */
/** 查询申请须知 */
export const findForApplicants = (success, fail) => {
  let url = BASE_URL + 'ForApplicants/findForApplicants'
  let params = {
    body: {
    }
  }
  return get(url, params, success, fail);
}

//查询专家基本信息
export const selectExpertimDto = ({ userid }, success, fail) => {
  let url = BASE_URL + 'expertInformation/selectExpertimDto'
  let params = {
    body: {
      userid: userid,
    }
  }
  return get(url, params, success, fail);
}

//专家基本信息添加
export const addInformation = ({ newsstate, basicstate, userid, name, gender, nation, health, birthdate, idno, workunit, address, workphone, phoneno, bank, bankaccount, job, email, nowmajor, techtitle,
  worklife, highesteduscl, sclmajor, graduationtime, education, degree, file, peopleimg, issuedby, issuingtime, arcdirection, asswork, political, start_time,
  orgnizationduty, rewart, items, diploma, jszyzm, sfzzm, sfzfm, oldPhone, xwzm }, success, fail) => {
  let url = BASE_URL + 'expertInformation/addInformation'
  let formData = new FormData();
  formData.append("userid", userid || '');//用户id
  formData.append("newsstate", newsstate || '');//管理端查询已处理、待处理时使用
  formData.append("basicstate", basicstate || '');//是否暂存
  formData.append("name", name || '');//姓名
  formData.append("gender", gender || '');//性别
  formData.append("nation", nation || '');//民族
  formData.append("health", health || '');//健康状况
  formData.append("birthdate", birthdate || '');//出生日期
  formData.append("idno", idno || '');//身份证号
  formData.append("phoneno", phoneno || '');//手机
  formData.append("oldPhone", oldPhone || '');//手机
  formData.append("email", email || '');//邮箱
  formData.append("nowmajor", nowmajor || '');//从事专业
  formData.append("worklife", worklife || '');//专业工作年限
  formData.append("political", political || '');//政治面貌
  formData.append("start_time", start_time || '');//入党时间
  formData.append("bankaccount", bankaccount || '');//银行卡账号
  formData.append("bank", bank || '');//开户银行
  formData.append("education", education || '');//学历
  formData.append("sclmajor", sclmajor || '');//所学专业
  formData.append("highesteduscl", highesteduscl || '');//毕业院校
  formData.append("graduationtime", graduationtime || '');//毕业时间
  formData.append("degree", degree || '');//学位
  formData.append("workunit", workunit || '');//工作单位
  formData.append("job", job || '');//行政职务
  formData.append("address", address || '');//通讯地址
  formData.append("workphone", workphone || '');//单位电话
  formData.append("techtitle", techtitle || '');//技术职称
  formData.append("issuedby", issuedby || '');//发证单位
  formData.append("issuingtime", issuingtime || '');//发证时间
  formData.append("arcdirection", arcdirection || '');//绿色建筑方向
  formData.append("asswork", asswork || '');//个人简介
  formData.append("orgnizationduty", orgnizationduty || '');//参加何种学术组织、担任何种职务
  formData.append("rewart", rewart || '');//受过何种奖励
  formData.append("items", JSON.stringify(items || ''));//执业注册信息
  if (file) {
    formData.append("file", file);//个人照片
  }
  if (diploma) {
    formData.append("diploma", diploma);//最高学历证明附件
  }
  if (jszyzm) {
    formData.append("jszyzm", jszyzm);//技术职称证明附件
  }
  if (sfzzm) {
    formData.append("sfzzm", sfzzm);//身份证正面
  }
  if (sfzfm) {
    formData.append("sfzfm", sfzfm);//身份证反面
  }
  if (xwzm) {
    formData.append("xwzm", xwzm); //最高学位证明附件路径
  }
  if (peopleimg) {
    formData.append("peopleimg", peopleimg);//照片路径
  }
  // items.map(item=>{
  //   formData.append("files",item);//执业资格证附件
  // })
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return post(url, params, success, fail);
}

/** 判断是否添加过专家基本信息 */
export const isExists = (success, fail) => {
  let url = BASE_URL + 'expertInformation/isExists'
  let params = {
    body: {
    }
  }
  return qsPost(url, params, success, fail);
}


/** 用户端活动报名列表接口 */
export const getActiveListForExpert = ({ currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + 'getActiveListForExpert'
  let params = {
    body: {
      currentPage: currentPage,//当前页
      pageSize: pageSize,//每页显示条数
    }
  }
  return qsPost(url, params, success, fail);
}

/** 已报名活动查询 */
export const getAlreadyApplyActive = ({ currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + 'getAlreadyApplyActive'
  let params = {
    body: {
      currentPage: currentPage,//当前页
      pageSize: pageSize,//每页显示条数
    }
  }
  return qsPost(url, params, success, fail);
}

/** 修改密码时发送验证码 */
export const getPhonecode = ({ phone_no }, success, fail) => {
  let url = BASE_URL + 'expertInformation/getPhonecode'
  let params = {
    body: {
      phone_no: phone_no,//手机号
    }
  }
  return qsPost(url, params, success, fail);
}

/** 修改密码 */
export const updatePwd = ({ phoneno, pwd, phoneCode }, success, fail) => {
  let url = BASE_URL + '/expertInformation/updatePwd'
  let params = {
    body: {
      phoneno: phoneno,//手机号码
      pwd: pwd,//新密码
      phoneCode: phoneCode,//手机验证码
    }
  }
  return qsPost(url, params, success, fail);
}

/** 添加专家申请 */
export const createExpertsApplyfor = ({ userid, applicant_id, experttype, referrer, workexperience, paperworks, scientificpayoffs, projectachievement, fileList, filepaths, is_accept_dispending, categories, other1, other2}, success, fail) => {
  let url = BASE_URL + 'Experts/createExpertsApplyfor'
  let formData = new FormData();
  formData.append("is_accept_dispending", is_accept_dispending);//是否接受调剂
  formData.append("userid", userid);//用户id
  formData.append("applicant_id", applicant_id);//申请信息编号
  formData.append("experttype", experttype);//申请专家类别
  formData.append("referrer", referrer);//推荐人
  formData.append("categories", categories);//
  formData.append("other1", other1);//
  formData.append("other2", other2);//
  formData.append("workexperience", workexperience);//相关工作经历
  formData.append("paperworks", paperworks);//相关论文著作
  formData.append("scientificpayoffs", scientificpayoffs);//相关科研成果
  formData.append("projectachievement", projectachievement);//相关工程项目业绩
  formData.append("filepaths", filepaths || []);//要删除的文件列表,逗号隔开
  if (fileList) {
    fileList.map((file) => {
      formData.append("uploaddate" + experttype, file);
    });
  }
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return post(url, params, success, fail);
}
// 专家申请暂存信息查询findExpertsApplyforByUidEid
export const findExpertsApplyforByUidEid = ({ experttype, userid }, success, fail) => {
  let url = BASE_URL + 'Experts/findExpertsApplyforByUidEid'
  let params = {
    body: {
      experttype: experttype,//专家申请类别
      userid: userid//用户信息编号
    }
  }
  return qsPost(url, params, success, fail);
}

// 专家申请暂存
export const createExpertsApplyforTS = ({ userid, applicant_id, experttype, referrer, workexperience, paperworks, scientificpayoffs, projectachievement, fileList, filepaths, is_accept_dispensing }, success, fail) => {
  let url = BASE_URL + 'Experts/createExpertsApplyforTS'
  let formData = new FormData();
  formData.append("is_accept_dispensing", is_accept_dispensing || '');//是否接受调剂
  formData.append("userid", userid || '');//用户id
  formData.append("applicant_id", applicant_id || '');//申请信息编号
  formData.append("experttype", experttype || '');//申请专家类别
  formData.append("referrer", referrer || '');
  formData.append("workexperience", workexperience || '');//相关工作经历
  formData.append("paperworks", paperworks || '');//相关论文著作
  formData.append("scientificpayoffs", scientificpayoffs || '');//相关科研成果
  formData.append("projectachievement", projectachievement || '');//相关工程项目业绩
  formData.append("filepaths", filepaths || '');//删除路径
  if (fileList) {
    fileList.map((file) => {
      formData.append("uploaddate" + experttype, file);
    });
  }
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return post(url, params, success, fail);
}

/** 修改专家申请 */
export const updateExpertsApplyforByApplicantid = ({ userid, applicant_id, experttype, referrer, workexperience, paperworks, scientificpayoffs, projectachievement, fileList, filepaths }, success, fail) => {
  let url = BASE_URL + 'Experts/updateExpertsApplyforByApplicantid'
  let formData = new FormData();
  formData.append("userid", userid);//用户id
  formData.append("applicant_id", applicant_id);//申请信息编号
  formData.append("experttype", experttype);//申请专家类别
  formData.append("referrer", referrer);//推荐人
  formData.append("workexperience", workexperience);//相关工作经历
  formData.append("paperworks", paperworks);//相关论文著作
  formData.append("scientificpayoffs", scientificpayoffs);//相关科研成果
  formData.append("projectachievement", projectachievement);//相关工程项目业绩
  formData.append("filepaths", filepaths);//要删除的文件列表,逗号隔开
  if (fileList) {
    fileList.map((file) => {
      if (!file.file_name) {
        formData.append("uploaddate1" + experttype, file);
      }
    });
  }
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return post(url, params, success, fail);
}
//获取专业列表
export const getMajorList = (success, fail) => {
  let url = BASE_URL + 'getMajorList'
  let params = {
    body: {
    }
  }
  return qsPost(url, params, success, fail);
}


//查询全部专家类别
export const getExpertCategory = ({ category_id, status }, success, fail) => {
  let url = BASE_URL + 'getExpertCategory'
  let params = {
    body: {
      category_id: category_id,//获取不同专家类别的申请须知
      status: status//获取专家类别菜单
    }
  }
  return qsPost(url, params, success, fail);
}

//我的任务-待接受任务
export const findPendingTask = ({ currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + 'MyTask/findPendingTask'
  let params = {
    body: {
      currentPage: currentPage,//当前页
      pageSize: pageSize,//每页显示条数
    }
  }
  return qsPost(url, params, success, fail);
}

//我的任务-需处理任务
export const findProcessedTask = ({ currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + 'MyTask/findProcessedTask'
  let params = {
    body: {
      currentPage: currentPage,//当前页
      pageSize: pageSize,//每页显示条数
    }
  }
  return qsPost(url, params, success, fail);
}

//活动报名反馈
export const activeApply = ({ activity_id, feedback }, success, fail) => {
  let url = BASE_URL + 'activeApplyFeedback'
  let params = {
    body: {
      activity_id: activity_id,//活动id
      feedback: feedback,//1 报名 2 不参加 3 不再接受邀请
    }
  }
  return qsPost(url, params, success, fail);
}

//我的申请-查看专家所有申请
export const findExpertsApplyfor = ({ currentPage, pageSize }, success, fail) => {
  let url = BASE_URL + 'Experts/findExpertsApplyfor'
  let params = {
    body: {
      currentPage: currentPage,//当前页
      pageSize: pageSize,//每页显示条数
    }
  }
  return qsPost(url, params, success, fail);
}

//查询与该用户相关的所有消息
export const selUserMessage = (success, fail) => {
  let url = BASE_URL + 'message/selUserMessage'
  let params = {
    body: {
    }
  }
  return qsPost(url, params, success, fail);
}
//查看站内信
export const queryMessageForExpert = ({ currentPage, pageSize, userid, status }, success, fail) => {
  let url = BASE_URL + 'queryMessageForExpert'
  let params = {
    body: {
      currentPage: currentPage,
      pageSize: pageSize,
      userid: userid,
      status: status,//0 已读 1 未读  传空查全部
    }
  }
  return qsPost(url, params, success, fail);
}

//修改消息的状态
export const readMessage = (id, success, fail) => {
  let url = BASE_URL + 'message/updstate'
  let params = {
    body: {
      id: id,
    }
  }
  return qsPost(url, params, success, fail);
}
//修改消息的状态(最新)
export const updateMsgStatus = ({ rel_id, status }, success, fail) => {
  let url = BASE_URL + 'updateMsgStatus'
  let params = {
    body: {
      rel_id: rel_id,
      status: status
    }
  }
  return qsPost(url, params, success, fail);
}
// 诉求反馈
export const addAppealInfo = ({ appeal_title, appeal_content, person_name, phone_no, user_id }, success, fail) => {
  let url = BASE_URL + 'addAppealInfo'
  let params = {
    body: {
      appeal_title: appeal_title,
      appeal_content: appeal_content,
      person_name: person_name,
      phone_no: phone_no,
      user_id: user_id
    }
  }
  return qsPost(url, params, success, fail);
}
// 获取诉求列表
export const queryAppealInfo = ({ currentPage, pageSize, user_id }, success, fail) => {
  let url = BASE_URL + 'queryAppealInfo'
  let params = {
    body: {
      currentPage: currentPage,
      pageSize: pageSize,
      user_id: user_id
    }
  }
  return qsPost(url, params, success, fail);
}
// 文件上传
export const uploadFile = ({ file, oldpath, type, userid }, success, fail) => {
  let url = BASE_URL + 'expertInformation/uploadFile'
  let formData = new FormData();
  formData.append("oldpath", oldpath);//执业注册信息
  formData.append("type", type);//执业注册信息
  formData.append("userid", userid);//执业注册信息
  if (file) {
    formData.append("file", file);//个人照片
  }
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return post(url, params, success, fail);
}
// 任务反馈
export const expertFeedback = ({ taskid, baseid, status }, success, fail) => {
  let url = BASE_URL + 'MyTask/expertFeedback'
  let params = {
    body: {
      taskid: taskid,
      baseid: baseid,
      status: status
    }
  }
  return qsPost(url, params, success, fail);
}
// 删除执业 
export const delSeniority = ({ Url }, success, fail) => {
  let url = BASE_URL + 'expertInformation/delSeniority'
  let params = {
    body: {
      Url: Url
    }
  }
  return get(url, params, success, fail);
}
// 下载申请表 Experts/downloadWord
export const downloadWord = ({ baseid, expertType }, success, fail) => {
  let url = BASE_URL + 'Experts/downloadWord'

  let formData = new FormData();
  formData.append("baseid", baseid);
  formData.append("expertType", expertType);
  let params = {
    body: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }
  return post(url, params, success, fail);
}
// 查看证书  /expertInformation/selEertificate
export const selEertificate = ({ baseid, experttype }, success, fail) => {
  let url = BASE_URL + 'expertInformation/selEertificate'

  let formData = new FormData();
  formData.append("baseid", baseid);
  formData.append("experttype", experttype);
  let params = {
    body: formData,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }
  return post(url, params, success, fail);
}

//是否写过申请 
export const isApply = ({ userid }, success, fail) => {
  let url = BASE_URL + 'Experts/expertAppliedExist';
  let formData = new FormData();
  formData.append("userid", userid);
  let params = {
    body: {
      userid: formData
    }
  }
  return qsPost(url, params, success, fail);
}



// WEBPACK FOOTER //
// ./src/api/ExpertLibraryAPI.js